import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  StyledDescriptionList,
  StyledFullWidthDLItem,
} from '../../BookingInformation.styles';

interface BookingTenantUserInformationProps {
  tenantFirstName: string;
  tenantLastName: string;
  tenantAge: number;
  tenantOccupation: string;
  tenantComment: string;
}

const BookingTenantUserInformation = ({
  tenantFirstName,
  tenantLastName,
  tenantAge,
  tenantOccupation,
  tenantComment,
}: BookingTenantUserInformationProps) => {
  const { t } = useTranslation(['booking', 'form']);
  return (
    <StyledDescriptionList>
      <div>
        <dt>{upperFirst(t('booking:tenantName'))}</dt>
        <dd>{`${tenantFirstName} ${tenantLastName}`}</dd>
      </div>
      <div>
        <dt>{upperFirst(t('booking:age'))}</dt>
        <dd>
          {tenantAge} {t('booking:yearsOld')}
        </dd>
      </div>
      <div>
        <dt>{upperFirst(t('booking:occupation'))}</dt>
        <dd>{t(`form:${tenantOccupation}`) ?? tenantOccupation}</dd>
      </div>
      <StyledFullWidthDLItem>
        <dt>{upperFirst(t('booking:tenantComment'))}</dt>
        <dd>{tenantComment}</dd>
      </StyledFullWidthDLItem>
    </StyledDescriptionList>
  );
};

export default BookingTenantUserInformation;
